
(function($){
	var serialize = function(obj, prefix) {
		var str = [],
		p;
		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + "[" + p + "]" : p,
				v = obj[p];
				str.push((v !== null && typeof v === "object") ?
					serialize(v, k) :
					encodeURIComponent(k) + "=" + encodeURIComponent(v));
			}
		}
		return str.join("&");
	};
	$(document).ready( function(){
		$( '.filter-toggle' ).on( 'click', function( e ){
			e.preventDefault();
			var open = $( this ).parent().hasClass( 'opened' );
			if ( open ) {
				$( this ).parent().removeClass( 'opened' );
			} else {
				$( this ).parent().addClass( 'opened' );
			}
		} );
		$( '.blog-filter-btn' ).on('click', function( e ){
			e.preventDefault();
			var urlBase = this.dataset.baseUrl;
			var filterData = {};

			$( '.blog-filter-check:checked' ).each(function(){
				var key = this.dataset.filterKey;
				if ( !filterData[key]  ) {
					filterData[key] = [];
				}
				var val = this.value;
				filterData[key].push(val);
			});

			var searchVal = $( 'input.search-field' ).val();
			if ( searchVal.length ) {
				filterData.search = searchVal;
			}
			// let params = new URLSearchParams();
			// params.append( 'filter', filterData );
			let params = serialize( filterData, 'filter' );
			// console.log( urlBase, params, filterData );
			location.href= urlBase + "?" + params;
		});
		var featureTemplate;
		var setFeaturedPost = function(){
			if ( FWP.settings.pager.page === 1 ) {
				var article = $( '.facetwp-template article' ).eq(0);
				var feature = {};
				feature.img = article.data( 'large-thumb' );
				feature.post_id = article.data( 'post-id' );
				feature.link = article.data( 'link' );
				feature.meta = $( '.post-meta', article ).html()
				feature.region = $( '.badge', article ).text();
				feature.title = $( 'h2', article ).text();
				feature.excerpt = $( '.post-excerpt', article ).html();

				var output = featureTemplate( feature );
				$( '.feature-box' ).html( output );
				article.addClass( 'd-none' );
			} else {
				$( '.feature-box' ).html( '' );
			}
		}
		$(document).on( 'facetwp-loaded', function(){
			featureTemplate = _.template( $( '#feature-template').html() );
			setFeaturedPost();
			$(document).on( 'facetwp-refresh', setFeaturedPost );
		} );
	} );
})(jQuery)